'use strict';

const page = require('../page'),
    login = require('../login'),
    appendParamToURL = require('../modules/util/appendParamToURL');

exports.init = function () {
    $('#editAddress').on('change', function () {
        page.redirect(appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();

};
